import http from "../http-common";

class AcademicPositionService {
  createAcademicPosition(data) {
    return http.post(`/api/academic_positions`, data);
  }
  getAcademicPosition() {
    return http.get(`/api/academic_positions`);
  }
  updateAcademicPosition(id, data) {
    return http.put(`/api/academic_positions/${id}`, data);
  }
}

export default new AcademicPositionService();